"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacementId = exports.AdServer = void 0;
var AdServer;
(function (AdServer) {
    AdServer["AFS"] = "afs";
    AdServer["Xandr"] = "xandr";
    AdServer["GAM"] = "google-ad-manager";
    AdServer["ContentMarketing"] = "content-marketing";
})(AdServer || (exports.AdServer = AdServer = {}));
var PlacementId;
(function (PlacementId) {
    PlacementId["Empty"] = "";
    PlacementId["Top1"] = "advt_top_1";
    PlacementId["Left1"] = "advt_left_1";
    PlacementId["Right1"] = "advt_right_1";
    PlacementId["Top2"] = "advt_top_2";
    PlacementId["Middle1"] = "advt_middle_1";
    PlacementId["Middle2"] = "advt_middle_2";
    PlacementId["Bottom1"] = "advt_bottom_1";
    PlacementId["RecircMiddle1"] = "advt_recirc_middle_1";
    PlacementId["RecircMiddle2"] = "advt_recirc_middle_2";
    PlacementId["AfsContainer1"] = "afs_container_1";
    PlacementId["AfsContainer2"] = "afs_container_2";
    /**
     * GAM
     */
    PlacementId["Gam_Right_1"] = "div-gpt-ad-1718706479071-0";
    PlacementId["Gam_Top_1"] = "div-gpt-top-1-ad-1718706479071-1";
    /**
     * These are temporary as they will be phased into the same naming convention as
     * the other NMP placements.
     */
    PlacementId["FinnLegendaryTop1"] = "topboard";
    PlacementId["FinnLegendaryRight1"] = "skyscraperright_1";
    PlacementId["FinnLegendaryLeft1"] = "skyscraperleft_1";
    PlacementId["FinnLegendaryWallpaper"] = "wallpaper";
})(PlacementId || (exports.PlacementId = PlacementId = {}));
